import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Upload Queue Context
 *
 * Provides the TUS upload queue functionality to the entire home feature.
 * Wraps the useUploadQueue hook and handles error notifications.
 */
import { createContext, useContext } from 'react';
import { useUploadQueue } from '../hooks/useUploadQueue';
import { useDialog } from './DialogContext';
const UploadQueueContext = createContext(undefined);
export const UploadQueueProvider = ({ children }) => {
    const { info } = useDialog();
    const uploadQueue = useUploadQueue({
        maxConcurrent: 1,
        chunkSize: 2 * 1024 * 1024, // 2MB
        autoStart: true,
        onUploadComplete: (item, result) => {
            console.log('[UploadQueue] Upload complete:', item.filename, result);
            // Silent completion - the progress panel shows status
            // Could show a toast here if desired
        },
        onUploadError: (item, error) => {
            console.error('[UploadQueue] Upload error:', item.filename, error);
            // Show error notification for auth errors
            const errorMessage = error.message || String(error);
            if (errorMessage.includes('401') ||
                errorMessage.includes('403') ||
                errorMessage.includes('Authentication')) {
                info({
                    title: 'Authentication Required',
                    message: 'Your session has expired. Please log in again to continue uploading.',
                    variant: 'error',
                });
            }
        },
    });
    return (_jsx(UploadQueueContext.Provider, { value: uploadQueue, children: children }));
};
/**
 * Hook to access the upload queue context
 * @throws Error if used outside of UploadQueueProvider
 */
export const useUploadQueueContext = () => {
    const context = useContext(UploadQueueContext);
    if (!context) {
        throw new Error('useUploadQueueContext must be used within an UploadQueueProvider');
    }
    return context;
};
export default UploadQueueContext;
